export default "__VITE_ASSET__CVuDdhkm__"